class UnexpectedResponseError extends Error {
  constructor(url, statusCode, errorResponse) {
    const message = `Unexpected response from the server: HTTP Status ${statusCode}`;
    super(message); // (1)
    this.name = "UnexpectedResponseError"; // (2)
    this.url = url;
    this.statusCode = statusCode;
    this.errorResponse = errorResponse;
  }
}

class NotFoundResponseError extends Error {
  constructor(url) {
    super('Resource not found');
    this.name = 'NotFoundResponseError';
    this.url = url;
  }
}

export async function handleAPIResponse(response) {
  if (response.status === 404) {
    throw new NotFoundResponseError(response.url);
  }
  if (response.status !== 200) {
    throw new UnexpectedResponseError(response.url, response.status, response);
  }

  return await response.json();
}

export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
